import { IAddressSchema } from "@faire/web-api--source/indigofair/data/IAddressSchema";
import { DEFAULT_ADDRESS_SCHEMA_OVERRIDE } from "@faire/web-api--source/indigofair/settings/DEFAULT_ADDRESS_SCHEMA_OVERRIDE";
import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";
var defaultValue = IAddressSchema.build();
export var getSettingDefaultAddressSchemaOverride = function() {
    return getSettingValueWithoutAssignment(DEFAULT_ADDRESS_SCHEMA_OVERRIDE, defaultValue);
};
